import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: "normal",
  color: COLORS.black,
};

export const H4 = ({ children, fontWeight, color }) => {
  return (
    <Typography variant="h4" sx={{ fontWeight, color }}>
      {children}
    </Typography>
  );
};

H4.propTypes = {
  fontWeight: PropTypes.string,
  color: PropTypes.string,
};

H4.defaultProps = defaultProps;

export default H4;
